import { Modal } from 'Components/Modal'
import { TextFieldWithLabel } from 'Components/TextField'
import { type globalSettingValue } from 'core/types'
import { useState } from 'react'

export interface NameMatchSettingDetailsProps {
  open: boolean
  onClose: () => void
  onSubmit: (newValue: globalSettingValue) => void
  setting: globalSettingValue
}

export function NameMatchSettingDetails (props: NameMatchSettingDetailsProps): JSX.Element {
  const [setting, setSetting] = useState(props.setting)
  const title = 'Name Match Setting'
  const handleClose = (): void => {
    props.onClose()
  }
  const handleChange = (e: any): void => {
    setSetting({ ...setting, [e.target.name]: e.target.value })
  }
  const handleSubmit = (): void => {
    props.onSubmit(setting)
  }

  const content = <>
    <TextFieldWithLabel
      label={setting.name}
      name='value'
      type='number'
      onChange={handleChange}
      value={setting.value}
    />
  </>
  return <Modal
    data-testid="modal"
    open={props.open}
    title={title}
    confirmationContent={content}
    onClose={handleClose}
    onConfirm={handleSubmit}
  />
}
